import React from 'react'
import Bevereges from '../Bevereges/Bevereges';
import Nigiri from '../Nigiri/Nigiri';
import Maki from '../Maki/Maki';
import Soups from '../Soups/Soups';
import Sweets from '../Sweets/Sweets';

export default () => {
  return (
    <div>
      <Soups/>
      <Nigiri/>
      <Maki/>
      <Sweets/>
      <Bevereges/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/Categories/All/All.js